import styled from "styled-components";
import { device } from "../device";
import PropTypes from "prop-types";

const H4 = styled.h4`
    margin: ${({type}) => 
        type === 'medium' ? '0 0 24px' : '0 0 8px'
    };
    font-size: ${({type}) => 
        type === 'medium' ? '18px' : '16px'
    };
    font-weight: 500;
    line-height: 1.2;
    @media ${device.lg} {
        margin: ${({type}) => 
            type === 'medium' ? '0 0 32px' : '0 0 8px'
        };
        font-size: ${({type}) => 
            type === 'medium' ? '24px' : '18px'
        };
    }
`;

H4.propTypes = {
    type: PropTypes.string
};

export default H4